import type { TagJSONObject, TagSummaryJSONObject } from '@ikegps/core-api';
import { ColorHash } from '@ikegps/core-shared';
import { getShowRedDot } from '../../components/red.dot/is.missing.true.size';
import { addStyles } from '../../components/theme';
import { m } from '../../mithril';
import { AppStore } from '../../store';
import { CSS, Style } from './tag.icon.style';

addStyles(Style);

export const TagIcon = {
	view(tag: TagJSONObject, summary?: TagSummaryJSONObject, color?: string, showRedDot?: boolean) {
		const value = summary != null ? summary.revisions.length : null;
		showRedDot = showRedDot || TagIcon.checkMissingTrueSize(summary);

		return m(
			'div',
			{
				className: CSS.container,
				style: {
					'border-color': ColorHash.hash(tag.objectId),
					'background-color': color ? color : '#FFFFFF',
				},
			},
			[value, showRedDot ? m('span', { className: CSS.redDot }) : null]
		);
	},

	checkMissingTrueSize(summary?: TagSummaryJSONObject): boolean {
		if (summary == null) {
			return false;
		}

		// If the server-side flag is already set, use it directly
		if (summary.hasCollectionsMissingTrueSize != null) {
			return summary.hasCollectionsMissingTrueSize;
		}

		// Fall back to checking individual collection summaries.
		// getShowRedDot caches computed values on each collection summary.
		for (const revision of summary.revisions) {
			const collSummary = AppStore.CollectionSummary.get(revision);
			if (collSummary != null && getShowRedDot(collSummary)) {
				summary.hasCollectionsMissingTrueSize = true;
				return true;
			}
		}

		return false;
	},
};
